module.exports = __webpack_public_path__ + "static/media/icon-facebook.efe5c553.svg";